<template>
    <div v-if="showMachineOrderVisiable">
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="订单编号：">
                <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.orderNo"
                    placeholder="请输入订单编号"></el-input>
            </el-form-item>
            <el-form-item label="订单状态：">
                <el-select v-model.number="formInline.state" placeholder="请选择订单状态" size="small" @change="getListData">
                    <el-option v-for="item in stateList" :label="item.name" :value="item.code"
                        :key="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否预警：">
                <el-select v-model.number="formInline.isWarningQuJing" placeholder="请选择是否预警" size="small"
                    @change="getListData">
                    <el-option label="全部" :value="0" :key="0"></el-option>
                    <el-option label="预警" :value="1" :key="1"></el-option>
                    <el-option label="未预警" :value="2" :key="2"></el-option>
                    <el-option label="超期" :value="3" :key="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单来源：">
                <el-select v-model.number="formInline.orderSource" placeholder="请选择订单来源" size="small"
                    @change="getListData">
                    <el-option v-for="item in orderSourceList" :label="item.name" :value="item.code"
                        :key="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="订单类型：">
                <el-select v-model.number="formInline.orderType" placeholder="请选择订单类型" size="small"
                    @change="getListData">
                    <el-option v-for="item in orderTypeList" :label="item.name" :value="item.code"
                        :key="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">
                    搜索
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
                <el-button size="small" plain icon="el-icon-search" @click="handleFilter()">高级筛选</el-button>
            </el-form-item>
        </el-form>
        <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
            @rowDBClick="handleRowDBClick" @selection-change="handleSelectionChange" border>
            <el-table-column align="center" slot="orderNo" label="订单编号" width="250" fixed="left">
                <template slot-scope="scope">
                    <el-link type="primary" size="small" @click="handleSeeDetail(scope.row)">
                        {{ scope.row.orderNo }}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column align="center" slot="days" label="天数" width="60">
                <template slot-scope="scope">
                    <span v-if="scope.row.state === 6 || scope.row.state === 10">
                        --
                    </span>
                    <span v-else-if="scope.row.days <= delayDays && scope.row.days >= 0" class="one_1">
                        {{ scope.row.days }}
                    </span>
                    <span v-else-if="scope.row.days < 0" class="one_2">
                        {{ scope.row.days }}
                    </span>
                    <span v-else>
                        {{ scope.row.days }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column slot="storeKDNo" label="门店快递单号" width="180">
                <template slot-scope="scope">
                    <el-link v-if="scope.row.storeKDNo" type="primary" size="small"
                        @click="openNewWindowSearchKuaiDi(scope.row.storeKDNo)">
                        {{ scope.row.storeKDNo }}
                    </el-link>
                    <span v-else>
                        {{ scope.row.storeKDNo }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column slot="storeKDNo" label="加工部快递单号" width="180">
                <template slot-scope="scope">
                    <el-link v-if="scope.row.jgbkdNo" type="primary" size="small"
                        @click="openNewWindowSearchKuaiDi(scope.row.jgbkdNo)">
                        {{ scope.row.jgbkdNo }}
                    </el-link>
                    <span v-else>
                        {{ scope.row.jgbkdNo }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column align="center" slot="linkOrderNo" label="原订单号" width="230">
                <template slot-scope="scope">
                    <el-link type="primary" size="small" @click="handleSeeYuanDetail(scope.row)">
                        {{ scope.row.linkOrderNo }}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="200" fixed="right" slot="actionHandle">
                <template slot-scope="scope">
                    <el-button v-if="btnPermission.edit && (scope.row.state === 1 || scope.row.state === 2)"
                        size="small" type="primary" class="el-icon-edit" @click="handleRowDBClick(scope.row)">修改
                    </el-button>
                    <el-button v-if="btnPermission.delete && scope.row.state === 1" size="small" type="danger"
                        class="el-icon-delete" @click="handleDeleteOrder(scope.row)">删除
                    </el-button>
                </template>
            </el-table-column>
        </STable>
        <!-- 分页组件 -->
        <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <filterMore ref="filterMore" @filterMoreCallBack="filterMoreCallBack"></filterMore>
        <storeDetail ref="storeDetail"></storeDetail>
    </div>
</template>

<script>
import {
    GetStoreOrderPageList
} from "@/api/storeOrderApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import { GetSystemBusinessConfigDetailByCode } from "@/api/systemApi.js";
import storeDetail from "./storeDtl.vue";
export default {
    data() {
        return {
            showMachineOrderVisiable: false,
            pageShow: true,
            loading: false, // 显示加载
            listData: [],
            selectionList: [],
            selectionRowKeyIds: [],
            // 分页参数
            pageparm: {
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            },
            formInline: {
                pageIndex: 1,
                pageSize: 10,
                customerPhone: "",
                customerName: "",
                startTime: "",
                endTime: "",
                belongStoreKeyId: "",
                orderNo: "",
                storeKDNo: "",
                jgbkdNo: "",
                state: 0,
                isWarningQuJing: 0,
                orderSource: 0,
                orderType: 0,
                customerKeyId: "",
            },
            columnsData: [], //显示列
            listColumns: [
                {
                    prop: "keyId",
                    label: "全选",
                    align: "center",
                    fixed: "left",
                    width: "55",
                    isKeep: true,
                    selection: true,
                },
                {
                    prop: "rowNumber",
                    label: "序号",
                    align: "center",
                    fixed: "left",
                    isKeep: true,
                    width: "80",
                },
                {
                    prop: "belongStoreName",
                    label: "所属门店",
                    fixed: "left",
                    isKeep: true,
                    width: "150",
                    align: "center",
                },
                {
                    prop: "customerInfo.name",
                    label: "顾客姓名",
                    fixed: "left",
                    width: "100",
                    align: "center",
                },
                {
                    slot: "orderNo",
                    label: "订单编号",
                    fixed: "left",
                    isKeep: true,
                    width: "100",
                },
                {
                    prop: "stateStr",
                    label: "订单状态",
                    fixed: "left",
                    isKeep: true,
                    width: "100",
                    align: "center",
                },
                {
                    prop: "orderTypeStr",
                    label: "订单类型",
                    fixed: "left",
                    isKeep: true,
                    width: "100",
                    align: "center",
                },
                {
                    prop: "orderDate",
                    label: "下单日期",
                    width: "100",
                    align: "center",
                },
                {
                    prop: "getOrderDate",
                    label: "取镜时间",
                    width: "100",
                    align: "center",
                },
                {
                    slot: "days",
                    label: "天数",
                    width: "60",
                    align: "center",
                },
                {
                    prop: "confirmUserName",
                    label: "确认人",
                    width: "100",
                    align: "center",
                },
                {
                    prop: "confirmTime",
                    label: "确认时间",
                    width: "160",
                    align: "center",
                },
                {
                    prop: "eyeGlassTypeStr",
                    label: "镜片类型",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "customerInfo.phone",
                    label: "顾客电话",
                    width: "130",
                    align: "center",
                },
                {
                    prop: "yanGuangShi",
                    label: "验光师",
                    width: "100",
                    align: "center",
                },
                {
                    prop: "jjInformation",
                    label: "镜架信息",
                    minWidth: "150",
                    align: "center",
                },
                {
                    prop: "machinTypeStr",
                    label: "加工类型",
                    minWidth: "100",
                    align: "center",
                },
                {
                    prop: "orderSourceStr",
                    label: "订单来源",
                    minWidth: "100",
                    align: "center",
                },
                {
                    slot: "storeKDNo",
                    label: "门店快递订单号",
                    width: "220",
                },
                {
                    slot: "jgbkdNo",
                    label: "加工部快递订单号",
                    width: "220",
                },
                {
                    slot: "linkOrderNo",
                    label: "原订单号",
                    width: "220",
                },
                {
                    prop: "creator",
                    label: "创建人",
                    width: "100",
                },
                {
                    prop: "createTime",
                    label: "创建时间",
                    width: "160",
                },
                {
                    prop: "editor",
                    label: "维护人",
                    width: "100",
                },
                {
                    prop: "updateTime",
                    label: "维护时间",
                    width: "160",
                },
            ],
            chooseTime: "",
            stateList: [],
            orderTypeList: [],
            orderSourceList: [],
            kdNo: "",
            delayDays: 1,
        };
    },
    // 注册组件
    components: {
        storeDetail,
    },
    created() {
        // 初始列
        this.getCheckBox(this.listColumns.map((item) => item.label));
    },
    computed: {},
    methods: {
        //展示加工订单
        showMachineOrder(customerKeyId) {
            this.showMachineOrderVisiable = true;
            this.formInline.customerKeyId = customerKeyId;
            this.getListData();
            this.GetEnumConfigListByCode();
            this.GetOrderSourceEnumConfigListByCode();
            this.GetOrderTypeListByCode();
        },
        //关闭加工订单
        closeMachineOrder() {
            this.showMachineOrderVisiable = false;
            this.formInline.customerKeyId = "";
        },
        //展示筛选框
        handleFilter() {
            let initForm = {
                initSearch: {
                    pageIndex: 1,
                    pageSize: 10,
                },
                formList: [
                    {
                        label: "下单日期：",
                        datePickerIsRange: true,
                        startProp: "startTime",
                        endProp: "endTime",
                        valueFormat: "yyyy-MM-dd",
                        pickerType: "daterange",
                    },
                    {
                        label: "门店快递号：",
                        prop: "storeKDNo",
                        input: true,
                    },
                    {
                        label: "加工部快递号：",
                        prop: "jgbkdNo",
                        input: true,
                    },
                ],
            };
            this.$refs.filterMore.filterShow(this.formInline, initForm);
        },
        // 获取筛选框
        getCheckBox(val) {
            let arr = this.listColumns.filter((v) => !val.includes(v.label));
            this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
        },
        changeTime(val) {
            if (val !== null) {
                this.formInline.startTime = val[0];
                this.formInline.endTime = val[1];
            } else {
                this.formInline.startTime = null;
                this.formInline.endTime = null;
            }
        },
        // 单击行数据
        handleRowClick(row) {
            this.$refs.edit.editShow(row);
        },
        // 获取预警天数
        GetSystemBusinessConfigDetailByCode() {
            GetSystemBusinessConfigDetailByCode({
                code: 'QuJingWarningDay',
            }).then((res) => {
                if (res.code == 1) {
                    this.delayDays = parseInt(res.data.delayDays) || 1;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 获取列表
        getListData() {
            this.loading = true;
            if (this.formInline.startTime == "") {
                this.formInline.startTime = null;
            }
            if (this.formInline.endTime == "") {
                this.formInline.endTime = null;
            }
            GetStoreOrderPageList(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.listData = res.data;
                        this.pageparm.total = res.totalNumber;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
                });
        },
        // 重置
        clearAll() {
            this.$data.formInline = this.$options.data.call(this).formInline;
            this.search();
        },
        inputChange(val) {
            this.search();
        },
        // 分页插件事件
        callFather(parm) {
            if (parm.currentPage == undefined) {
                this.formInline.pageIndex = 1;
            } else {
                this.formInline.pageIndex = parm.currentPage;
            }
            this.formInline.pageSize = parm.pageSize;
            this.getListData();
        },
        // 搜索事件
        search() {
            this.formInline.pageIndex = 1;
            this.pageShow = false;
            this.$nextTick(() => {
                this.pageShow = true;
            });
            this.getListData();
        },
        //获取状态信息
        GetEnumConfigListByCode() {
            const paramer = {
                code: "StoreOrderState",
            };
            GetEnumConfigListByCode(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.stateList = [];
                        res.data.forEach((item) => {
                            this.stateList.push({
                                code: parseInt(item.code),
                                name: item.name,
                            });
                        });
                        this.stateList.unshift({
                            code: 0,
                            name: "全部",
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取状态信息失败!");
                });
        },
        //获取订单类型信息
        GetOrderTypeListByCode() {
            const paramer = {
                code: "OrderType",
            };
            GetEnumConfigListByCode(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.orderTypeList = [];
                        res.data.forEach((item) => {
                            this.orderTypeList.push({
                                code: parseInt(item.code),
                                name: item.name,
                            });
                        });
                        this.orderTypeList.unshift({
                            code: 0,
                            name: "全部",
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取状态信息失败!");
                });
        },
        //获取订单来源信息
        GetOrderSourceEnumConfigListByCode() {
            const paramer = {
                code: "StoreOrderSource",
            };
            GetEnumConfigListByCode(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.orderSourceList = [];
                        res.data.forEach((item) => {
                            this.orderSourceList.push({
                                code: parseInt(item.code),
                                name: item.name,
                            });
                        });
                        this.orderSourceList.unshift({
                            code: 0,
                            name: "全部",
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取订单来源信息失败!");
                });
        },
        // 高级筛选回调
        filterMoreCallBack(params) {
            this.formInline = params;
            this.search();
        },
        // 查看详情
        handleSeeDetail(row) {
            this.$refs.storeDetail.showSeeDetailDialog(row, 1);
        },
        // 查看原订单详情
        handleSeeYuanDetail(row) {
            this.$refs.storeDetail.showSeeDetailDialog(row, 2);
        },
        //打开新窗口查询快递信息
        openNewWindowSearchKuaiDi(val) {
            if (val.startsWith("SF")) {
                window.open("https://www.sf-express.com/chn/sc/waybill/waybill-detail/" + val);
            }
            else {
                this.$message({
                    type: "error",
                    message: "不是顺丰单号，不支持快递信息查询！",
                });
            }
        },
    },
};
</script>

<style scoped>
.one_1 {
    background-color: rgb(250, 121, 1);
    display: block;
    color: white;
    font-weight: bolder;
}

.one_2 {
    background-color: rgb(255, 0, 0);
    display: block;
    color: white;
    font-weight: bolder;
}
</style>